import { Container, Button,Alert,Table, Modal, Col, Row , Form} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "../ContentStyles";

import { FaFilePdf, FaReceipt, FaEnvelope,FaBars, FaCog, FaKey } from 'react-icons/fa';
import useBackend, {CallAPI, Loading, SpinnerX, IsLoggedIn } from '../../services/useBackend_v2';
import React, {useMemo, useState, useEffect } from 'react';
import {useParams, useNavigate, useSearchParams} from 'react-router-dom';
import MaterialReactTable from 'material-react-table';
import {Branding, DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO, getOptions, AddTimezoneOffset} from '../../services/misc';

import {priceplan} from '../PricingModule';

export default function MyComponent() {
    const { loading, data, Refresh, resultVariant, resultVisible, resultText, Update, XCall } = useBackend('/api/admin/shops');

    var {loggedIn, isAdmin, isSuperUser, userName, accountIsLocked} = IsLoggedIn();

    const [modalshow,  setModalshow] = useState(false);    
    const initModal = () => { return setModalshow(!modalshow) } 

    const [modalshowAddShop,  setModalshowAddShop] = useState(false);    
    const initModalAddShop = () => { return setModalshowAddShop(!modalshowAddShop) }     

    const [selectedShopData, setSelectedShopData]   = useState({Name:"...", Description:"", OpeningHoursLocalStart:"00:00:00", OpeningHoursLocalEnd:"00:00:00", EntryCode:{ Code:"" }, Doors:[] });

    const navigate = useNavigate();

    if (accountIsLocked) navigate("/instance/invoices");

    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 25 });

    useEffect(() => { navigate('?pageindex='+pagination.pageIndex+'&pagesize='+pagination.pageSize) }, [pagination]);

    const detailShopClick = async (event, rowData)  =>  {
        let { resultVariant, resultVisible, resultText, jsondata } = await CallAPI('/api/admin/shop/'+rowData.original.Guid+'',"GET");     
        setSelectedShopData(jsondata.Shop)
        setModalshow(!modalshow);
    }

    const editShopClick = (event)  =>  {
        const ShopGUID = event.currentTarget.getAttribute("shopguid");
        event.preventDefault();
        navigate("/shop/" + ShopGUID);
    }

    const addShopHandler = (event)  =>  {
        event.preventDefault();
        initModalAddShop();
    }    
    
    const columns = useMemo(() => [
        { size: 20, accessorKey: 'Name',        header: '#', enableColumnActions: false, enableHiding:false },
        { size: 100, accessorKey: 'Description', header: 'Description' },
        { size: 100, accessorKey: 'Company',     header: 'Company', headerClassName: 'test_'},                  
      ]
    );  

    const initialState = 
    { 
        density: 'compact',
        columnVisibility: { Company: false, Description:true }, 
        pagination : pagination 
    };  

    const state = { pagination : pagination };      

    async function unLockShop(event){
        const doorguid = event.currentTarget.getAttribute("doorguid");
        await XCall('/api/admin/shop/'+selectedShopData.Guid+'/Unlockdoor/' + doorguid, "PUT", 3000);
    }

    if (!loading) {
        return (
            <ContentWrapper>
                <ModalAddShop show={modalshowAddShop} onHide={initModalAddShop} refreshFunction={()=> { Refresh();}} ></ModalAddShop>

                <Modal show={modalshow} onHide={initModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>{selectedShopData.Description} ({selectedShopData.Name})</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <div style={{display: 'flex', width_:'100%', background_:'#ccc', marginTop:'12px'}}>
                            <div style={{float:'left', width:'100%', background_:'#ff00ff'}}>
                                <Row><Col>Företag</Col><Col>{selectedShopData.Company}</Col></Row>
                                <Row><Col>Minsta ålder</Col><Col>{selectedShopData.MinCustomerAge}</Col></Row>
                                <Row><Col>Öppettider</Col><Col>{SplitoutLocalTimeFromISO(selectedShopData.OpeningHoursLocalStart)}&nbsp; till &nbsp;{SplitoutLocalTimeFromISO(selectedShopData.OpeningHoursLocalEnd)}</Col></Row>
                                <Row><Col>EntryCode</Col><Col>{selectedShopData.EntryCode}</Col></Row>
                            </div>

                            <div style={{float:'right', clear:'both', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', background_:'#00ff00'}}>
                                <Button className="QmeButton_" variant="secondary" type="button" shopguid={selectedShopData.Guid} onClick={editShopClick}><FaCog/></Button>
                            </div>
                        </div>
                        
                        { selectedShopData.Doors.map((door) => {
                            return <div style={{display: 'flex', width_:'100%', background_:'#ccc', marginTop:'12px'}}>
                                <div style={{float:'left', width:'100%', background_:'#ff00ff'}}>
                                    <Row><Col><b>{door.Description}</b></Col></Row>
                                    <Row><Col>DeviceType</Col><Col>{door.LockType}</Col></Row>
                                    
                                    <Row><Col>Dörr</Col><Col><font color={door.DoorClosed ? "#4da850" : "#ff0000"}><b>{door.DoorClosed ? "Stängd":"Öppen"}</b></font></Col></Row>
                                    <Row><Col>Uppkoppling</Col><Col><font color={door.Online ? "#4da850" : "#ff0000"}><b>{door.Online ? "Online":"Offline"}</b></font></Col></Row>
                                    <Row><Col>Senaste kontakt</Col><Col>{DateTimeToLocal(door.LastPing)}</Col></Row>
                                    <Row><Col>Signalstyrka (dBm)</Col><Col>{door.RSSI}</Col></Row>
                                </div>

                                <div style={{float:'right', clear:'both', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', background_:'#00ff00'}}>
                                    <Button className="QmeButton_"  variant="primary" type="button" style={{backgroundColor:Branding().ButtonColor}} doorguid={door.Guid} onClick={unLockShop}><FaKey/></Button>
                                </div>
                            </div>
                            
                        })}
                        <div style={{marginTop:'12px'}}>
                            <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert>
                        </div>

                  </Modal.Body>
                  <Modal.Footer>                                                                              
                    <Button variant="danger" onClick={initModal}>Close</Button>
                  </Modal.Footer>
                </Modal>

                <Container>
                    <Sida>                    
                        <MaterialReactTable  columns={columns} data={data.Shops} 
                            muiTablePaginationProps={{ showFirstButton: false, showLastButton: false ,labelRowsPerPage:"Rader", rowsPerPageOptions: [25, 50, 100]}}
                            renderTopToolbarCustomActions={() => (<Rubrik>Butiker</Rubrik>)} initialState={initialState} onPaginationChange={setPagination} state={state} 
                                muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }} 
                                
                                muiTableBodyRowProps={({ row }) => ({
                                    onClick: (event) => {
                                        detailShopClick(event, row);
                                    },
                                    sx: {
                                    cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                    },
                                })}
                        />                                            
                        <Button className="QmeButton" style={{backgroundColor:Branding().ButtonColor}} variant="primary" type="submit"  onClick={addShopHandler}>Lägg till butik</Button>&nbsp;&nbsp;
                    </Sida>
                </Container>
            </ContentWrapper>            
        );
    } else {
        return (<Loading />);         
    }
}

export function ModalAddShop(props) {
    const { loading, data, Refresh, errorsException, resultVariant, resultVisible, resultText, Update, XCall } = useBackend('');
    const [selectedPlan, setSelectedPlan] = useState({planId : 0, title : 'Välj butiksalternativ', details:[]});    

    const handleClaimSubmit = async (e) =>{
        e.preventDefault();
        const ShopForm = document.getElementById('AddShopForm');
        const formData = new FormData(ShopForm), formDataObj = Object.fromEntries(formData.entries())

        formDataObj.SelectedPlan = selectedPlan;
        await XCall('/api/admin/shop', 'POST', 3000, formDataObj);

        if (errorsException==false) props.onHide();
        props.refreshFunction();
    }      

    return (
        <Modal show={props.show} onHide={props.onHide} onShow={() => setSelectedPlan({planId : 0, title : 'Välj butiksalternativ', details:[]})}>
            <Modal.Header closeButton>
                <Modal.Title>Skapa ny butik</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form id="AddShopForm">

                    <Form.Group className="mb-3" >
                        <Form.Label>Namn på butiken/kylskåpet</Form.Label>
                        <Form.Control type="text" name ="Name" placeholder="Ange namn på butiken/kylskåpet" />                            
                    </Form.Group>

                    <Form.Group className="mb-3" >
                        <Form.Label>Butiksalternativ</Form.Label>
                        <Form.Select id="SelectedPlan" name="SelectedPlan" defaultValue={0} onChange={(e) => setSelectedPlan(priceplan.plans.find(p => p.planId==e.target.value))}>                                    
                            <option value={{}} disabled>Välj butiksalternativ</option>
                            {priceplan.plans.map((p) => (<option value={p.planId}>{p.title} ({p.price}:-{p.period})</option>))}
                        </Form.Select>
                        <Form.Text id="" muted>
                            {selectedPlan.details.map((d, idx) => (
                                <div key={idx} className={`pricing-row ${d.isExample ? "pricing-row--example" : ""}`} role="listitem">
                                    <div className="pricing-row__label">{d.label}</div>
                                    <div className="pricing-row__value">{d.value}</div>
                                </div>
                            ))}
                        </Form.Text>
                    </Form.Group>                               

                    <Form.Group className="mb-3" >
                        <Form.Label>ID på låsmodul/kylskåp</Form.Label>
                        <Form.Control type="text" name ="DeviceId" placeholder="" />       
                        <Form.Text id="" muted>Har du redan låsmodul/kylskåp så kan du fylla i uppgifterna redan nu, annars lämnar du detta blankt.</Form.Text>                                                         
                    </Form.Group>      

                    <Form.Group className="mb-3"  hidden={!loading}>
                        <SpinnerX  />
                    </Form.Group>                                      
                        
                    <Form.Group className="mb-3"  hidden={!resultVisible}>
                        <Alert variant={resultVariant} className="FormSpace">{resultText}</Alert> 
                    </Form.Group>
                </Form>                      
                <Button className="QmeButton" type="submit" onClick={handleClaimSubmit}>Skapa butiken</Button>  
            </Modal.Body>
            
            <Modal.Footer>
                <Button variant="danger" onClick={props.onHide}>Close</Button>                        
            </Modal.Footer>
        </Modal>
    );
}